import { render, staticRenderFns } from "./WidgetToolbar.vue?vue&type=template&id=7754ef8f&scoped=true"
import script from "./WidgetToolbar.vue?vue&type=script&lang=js"
export * from "./WidgetToolbar.vue?vue&type=script&lang=js"
import style0 from "./WidgetToolbar.vue?vue&type=style&index=0&id=7754ef8f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7754ef8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7754ef8f')) {
      api.createRecord('7754ef8f', component.options)
    } else {
      api.reload('7754ef8f', component.options)
    }
    module.hot.accept("./WidgetToolbar.vue?vue&type=template&id=7754ef8f&scoped=true", function () {
      api.rerender('7754ef8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/WidgetToolbar.vue"
export default component.exports